import { OnlineSalesUnauthenticated } from 'gw-edge-client';
import { type ProductSelectorDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto';
import { type PreliminaryQuestionsDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/quote';
import { type AllCoverablesOnsaDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/onsa';
import { useRecoilValue } from 'recoil';
import { jobInfoAtom } from '../recoil/atoms/jobInfoAtom';
import { isLoggedOnSelector } from '../recoil/selectors/isLoggedOnSelector';

export function useStartOnsaFlow(): {
    startOnsaFlow: (
        productList: ProductSelectorDTO,
        preliminaryQuestionsAnswers: PreliminaryQuestionsDTO
    ) => Promise<AllCoverablesOnsaDTO>;
} {
    const { jobNumber, sessionId } = useRecoilValue(jobInfoAtom);

    const isLoggedOn = useRecoilValue(isLoggedOnSelector);

    const startOnsaFlow = async (
        productList: ProductSelectorDTO,
        preliminaryQuestionsAnswers: PreliminaryQuestionsDTO
    ): Promise<AllCoverablesOnsaDTO> => {
        return await OnlineSalesUnauthenticated.startONSAFlow(
            jobNumber,
            productList,
            preliminaryQuestionsAnswers,
            sessionId,
            !isLoggedOn
        );
    };

    return { startOnsaFlow };
}
